<template>
  <div class="not_eng_item_box_aa">
    <div class="not_eng_item" v-for="item in listArr" :key="item.id">
      <img :src="item.pictureUrl" alt @click="detailClick(item)" />
      <p class="p1">{{item.modifyTimes}}</p>
      <p class="p2" @click="detailClick(item)"><b>{{item.title}}</b></p>
    </div>
  </div>
</template>
<script>
// import middleKey from "../components/middleKey.vue"; //中间件
export default {
  components: {},
  data() {
    return {
      listArr: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    consultation() {
      let that = this;
      that.ajaxJson({
        url: "/siteManage/contentList",
        data:{
          type: 1
        },
        success: function(data) {
          if (data.code == "0000") {
            console.info(data);
            that.listArr = data.data;
          }
        }
      });
    },
    detailClick(item) {
      let that = this;
      that.$router.push({name:'detail',query: item})
    }
  },
  created() {
    let that = this;
    that.consultation();
  }
};
</script>
<style>
/* .index-footer {
  background: #fff;
  border-top: rgba(34, 34, 34, 0.1) solid 1px;
  position: relative;
  bottom: 0;
} */
.index-footer_box {
  padding: 47px 260px;
}
.index-footer_bom .index-footer_bom_box {
  padding: 0px 260px;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: rgba(154, 154, 154, 1);
  line-height: 36px;
}
.index-footer_bom {
  background: rgba(247, 247, 247, 1);
}
.index-footer_box .span1 {
  display: inline-block;
  padding-top: 30px;
}
.notice_right_news {
  display: inline-block;
  border-left: rgba(34, 34, 34, 0.1) solid 1px;
  padding: 0 60px;
  border-right: rgba(34, 34, 34, 0.1) solid 1px;
}
.notice_right_news .notice_right_phone {
  height: 36px;
  font-size: 36px;
  font-family: Helvetica;
  color: rgba(34, 34, 34, 1);
  line-height: 36px;
}
.notice_right_news .notice_right_title {
  height: 16px;
  font-size: 16px;
  font-family: Helvetica;
  color: rgba(34, 34, 34, 1);
  line-height: 16px;
}
.notice_right_news .notice_right_border {
  width: 15px;
  height: 2px;
  background: rgba(34, 34, 34, 1);
  margin: 10px 0 12px 0;
}
.notice_right_news .notice_right_data1 {
  height: 14px;
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(154, 154, 154, 1);
  line-height: 8px;
}
.notice_right_news .notice_right_data2 {
  height: 14px;
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(154, 154, 154, 1);
  line-height: 20px;
}
.notice_right_news .notice_content {
  width: 1px;
  height: 115px;
  background: rgba(34, 34, 34, 1);
  opacity: 0.5;
}
.index-footer_code img {
  /* width: 78px; */
  display: inline-block;
}
.index-footer_code .index-footer_wexin {
  padding-top: 70px;
}
.not_eng_item_box_aa {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.not_eng_item{
  padding: 10px;
}
.not_eng_item img {
  width: 310px;
  /* height: 185px; */
}
.not_eng_item .p2 {
  font-size: 24px;
  width: 310px;
  font-family: Helvetica;
  color: rgba(0, 0, 0, 1);
  /* line-height: 24px; */
     text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
.not_eng_item:hover{
    background: rgba(247,247,247,1);
    cursor:pointer
}
</style>


// WEBPACK FOOTER //
// src/components/page/aa.vue